import React from 'react';

import { CardBrandArt } from '@src/features/payments/components/CardBrandArt';
import type { PaymentBrand } from '@src/domains/payments';

import { BrandBadge, BrandList } from './styles';

const BADGE_WIDTH = 34;

type PaymentMethodBrandsProps = {
  brands: PaymentBrand[] | null;
};

export const PaymentMethodBrands = (props: PaymentMethodBrandsProps) => {
  const { brands } = props;

  const codes = [...new Set((brands ?? []).map((brand) => brand.code.toLowerCase()))];

  if (codes.length === 0) {
    return null;
  }

  return (
    <BrandList>
      {codes.map((code) => (
        <BrandBadge key={code} data-testid={`payment-method-brand-${code}`}>
          <CardBrandArt code={code} width={BADGE_WIDTH} />
        </BrandBadge>
      ))}
    </BrandList>
  );
};

export default PaymentMethodBrands;
